import React, { Component, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as commomactions from '../../common.action';
import AnexoPage from './anexo.page';
import AnexoModal from './modal/anexo.modal';
import WebapiCommon from '@common/util/webapi.common';

class AnexoContainer extends Component {

  constructor() {
    super();
    this.state = {
      listagem: [],
      previewFileUrl : undefined,
      preview: false,
      file : undefined,
      contentType : 'application/pdf',
      fileType : 'pdf',
      fileName : '',
    };

  }

  render() {
    return (
      <div>
      <AnexoPage
        altura={this.props.altura}
        listagem={this.state.listagem}
        download={this.download.bind(this)}
        alturaEditor={this.getAltura.bind(this)}
        previewFileUrl={this.state.previewFileUrl}
        setPreview={(e)=>  this.setState({ preview: e })}
        preview={this.state.preview}
      />
      <AnexoModal
        fileType={this.state.fileType.toLowerCase()}
        fileUrl={this.state.previewFileUrl}
        isOpen={this.state.preview}
        fileName={this.state.fileName}
        onRequestClose={()=>  this.setState({ preview: false })}
      />
      </div>
    );
  }

  componentDidMount() {
    commomactions.showFadeCarregando(true);
    WebapiCommon.getListagemAnexo(this.props.detalhes.laudo).then(
      (response) => {
        this.setState({ listagem: response });
        commomactions.showFadeCarregando(false);
      }
    );
  }

  getAltura = () => {
    return (
      document.getElementById('container-editor') &&
      document.getElementById('container-editor').style.height
    );
  };

  download(id, nome, contentType) {
    commomactions.showFadeCarregando(true);
    WebapiCommon.downloadAnexo(id)
      .then((response) => response.arrayBuffer())
      .then((res) => {
        var buffer = res;
        var view = new Uint8Array(buffer);
        for (var i = 0; i < res; i++) {
            view[i] = binary.charCodeAt(i);
        }
        var blob = new Blob( [view], { type: contentType });
        var url = URL.createObjectURL(blob);
        this.setState({ previewFileUrl: url });
        this.setState({ preview: true });
        this.setState({ file: arrayBufferToBase64(buffer) });
        this.setState({ contentType:  contentType});
        let fileType = 'file';

        if (contentType.toLowerCase()=== 'application/pdf'){
          fileType = 'pdf';
        }
        else  if (contentType.toLowerCase().indexOf('image')>-1){
          fileType = 'image';
        }
        this.setState({ fileName:  nome});
        this.setState({ fileType:  fileType});
        commomactions.showFadeCarregando(false);
      });
  }
}

const arrayBufferToBase64 =( buffer ) =>{
  var binary = '';
  var bytes = new Uint8Array( buffer );
  var len = bytes.byteLength;
  for (var i = 0; i < len; i++) {
      binary += String.fromCharCode( bytes[ i ] );
  }
  return window.btoa( binary );
}

const mapDispatchToProps = (dispatch) => {
  return {
    commonActions: bindActionCreators(commomactions, dispatch),
  };
};

const mapStateToProps = (state) => {
  return {
    detalhes: state.commonReducer.detalhes,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AnexoContainer);



// WEBPACK FOOTER //
// ./src/app/common/tabs/anexo/anexo.container.js